import { render, staticRenderFns } from "./OperatorAvatar.vue?vue&type=template&id=454c202b"
import script from "./OperatorAvatar.vue?vue&type=script&lang=js"
export * from "./OperatorAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports